import { FieldRadioGroup, Question } from '@workspace/core-ts/components';
import { SmartFormGlobal, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { OrdinateurTchat } from '@workspace/core-ts/icons-amo';
import { AvReasonArray } from '@/AvReason';
import type { FormSchemaType } from '@/schema';

export default function SelectionMotifAvenant() {
    const methods = useSmartFormGlobal<FormSchemaType>();

    return (
        <SmartFormGlobal {...methods} className="mx-auto max-w-2xl">
            <Question>
                <Question.Header>
                    <OrdinateurTchat />
                    <Question.Title>
                        Quel est le <b>motif de votre avenant</b> ?
                    </Question.Title>
                </Question.Header>

                <FieldRadioGroup
                    name="DemandeTarif.Police.MotifAvenant"
                    options={AvReasonArray}
                />
            </Question>
        </SmartFormGlobal>
    );
}